exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(min-width:1024px){.categories .flickity-viewport{margin:0 50px}}.list-item{display:inline-block;margin-right:10px}.list-enter-active,.list-leave-active{transition:all .5s}.list-enter,.list-leave-to{opacity:0;transform:translateY(30px)}.v-spinner .v-clip{border-width:3px!important;-webkit-animation:v-myClipDelay 1s linear 0s infinite;animation:v-myClipDelay 1s linear 0s infinite}@-webkit-keyframes v-myClipDelay{to{transform:rotate(1turn) scale(1)}}@keyframes v-myClipDelay{to{transform:rotate(1turn) scale(1)}}", ""]);

// exports
